import { render } from "./property-featurenew.vue?vue&type=template&id=f2d1c594"
import script from "./property-featurenew.js?vue&type=script&lang=js"
export * from "./property-featurenew.js?vue&type=script&lang=js"

import "./property-featurenew.vue?vue&type=style&index=0&id=f2d1c594&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__